import { EditorPlugin, FabricEditor, FabricEditorCanvas } from 'modules/fabric-editor';
import { selectActiveTemplate } from 'modules/manager/store';
import React from 'react';
import { useAppSelector } from 'store/hooks';

export interface EditorCanvasProps {
  plugins: EditorPlugin[];
  onReady: (editor: FabricEditor) => void;
}

const EditorCanvas: React.FC<EditorCanvasProps> = ({ plugins, onReady }) => {
  const activeTemplate = useAppSelector(selectActiveTemplate);

  if (!activeTemplate) return null;

  return (
    <FabricEditorCanvas
      key={`${activeTemplate.id}-${activeTemplate.width}x${activeTemplate.height}`}
      resolution={{ width: activeTemplate.width, height: activeTemplate.height }}
      autoFit
      plugins={plugins}
      onReady={onReady}
      className="flex-1"
    />
  );
};

export default EditorCanvas;
